/**
 * App 登录态消息邮箱。
 *
 * booking-platform 通过 React.lazy 加载。鸿蒙 WebView 可能在业务 chunk
 * 挂载监听器之前就回传 setUserInfo，因此需要由主 bundle 提前保存最近一条消息。
 */

let latestAppAuthMessage: Record<string, any> | null = null;
let captureInstalled = false;

export function normalizeAppBridgeMessage(rawData: unknown): Record<string, any> | null {
  let data = rawData;

  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (_) {
      return null;
    }
  }

  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    return null;
  }

  return data as Record<string, any>;
}

function captureAppAuthMessage(event: MessageEvent): void {
  const data = normalizeAppBridgeMessage(event.data);
  if (!data) {
    return;
  }

  if (data.type === 'setUserInfo') {
    latestAppAuthMessage = data;
  } else if (data.type === 'appLogout') {
    latestAppAuthMessage = null;
  }
}

export function installAppAuthMessageCapture(): void {
  if (captureInstalled || typeof window === 'undefined') {
    return;
  }

  captureInstalled = true;
  window.addEventListener('message', captureAppAuthMessage);
}

export function getLatestAppAuthMessage(): Record<string, any> | null {
  return latestAppAuthMessage;
}

export function clearLatestAppAuthMessage(): void {
  latestAppAuthMessage = null;
}

